import { useEffect } from 'react'

import { Grid, GridItem } from '@chakra-ui/react'
import { AgoraCloudProxyMode } from 'src/lib/gql-client'

import { VideoCallScene } from '../../types'
import { VideoCallRoomControl } from '../VideoCallRoomControl/VideoCallRoomControl'
import { VideoCallRoomMainContent } from '../VideoCallRoomMainContent/VideoCallRoomMainContent'
import { VideoCallRoomProvider } from '../VideoCallRoomProvider/VideoCallRoomProvider'

type Props = {
  token: string
  videoCallUserUid: number
  screenShareUserUid: number
  canShareScreen: boolean
  roomUid: string
  screenShareToken: string
  scene: VideoCallScene
  agoraCloudProxyMode: AgoraCloudProxyMode
  /** room退出時に画面に表示するメッセージ（optional）
   *
   * @default "ビデオ通話を終了しました。"
   */
  endedText?: string
  sendNotification?: () => void
}

export const VideoCallRoom: React.FC<Props> = ({
  token,
  videoCallUserUid,
  endedText = 'ビデオ通話を終了しました。',
  canShareScreen,
  screenShareUserUid,
  screenShareToken,
  sendNotification,
  roomUid,
  scene,
  agoraCloudProxyMode,
}) => {
  // コントロールボタンが隠れないよう、ヘッダーの高さ分だけtoastの表示位置を下げる
  useEffect(() => {
    const toastContainer = document.getElementById('chakra-toast-manager-top')
    if (!toastContainer) return
    const defaultTop = toastContainer.style.top
    toastContainer.style.top = '80px'
    return () => {
      toastContainer.style.top = defaultTop
    }
  }, [])

  return (
    <VideoCallRoomProvider
      token={token}
      screenShareUserUid={screenShareUserUid}
      screenShareToken={screenShareToken}
      roomUid={roomUid}
      videoCallUserUid={videoCallUserUid}
      scene={scene}
      agoraCloudProxyMode={agoraCloudProxyMode}
    >
      <Grid
        h="100svh"
        w="100svw"
        autoFlow="column"
        gridTemplateRows="80px minmax(0, 1fr)"
      >
        <GridItem>
          <VideoCallRoomControl canShareScreen={canShareScreen} />
        </GridItem>
        <GridItem bg="gray.800">
          <VideoCallRoomMainContent
            endedText={endedText}
            sendNotification={sendNotification}
          />
        </GridItem>
      </Grid>
    </VideoCallRoomProvider>
  )
}
